import { InteractionStatus } from "@azure/msal-browser";
import { Route, Redirect } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useSelector } from "react-redux";
import React from "react";

import { useStyles } from "./style";
import NavBar from "app/components/molecules/navbar/NavBar.mui";
import Statusbar from "app/components/atoms/statusbar/Statusbar.mui";

const PrivateRoute = ({
  component: Component,
  siteNav,
  checkTermination = false,
  ...rest
}) => {
  // Initialisation
  const saiceConnectRoutes = ["/saice-connect/mentoring/manage-availability", "/saice-connect/mentoring/review-requests", "/saice-connect/mentorship/manage-availability", "/saice-connect/mentorship/manage-availability", "/saice-connect/employment/view-profile-requests", "/saice-connect/employment/view-profile-requests/:id", "/saice-connect/employment/opt-in-to-employer-search"];

  // State

  // Others
  const userEntitlement = useSelector((state) => state.entitleMents);
  //TODO: remove "Active" when account status this configured
  const accountStatus = "Active"; 
  const isAccountOnHold = useSelector((state) => state.isAccountOnHold);
  const isTerminated = useSelector((state) => state.isTerminated);
  const isAccountOnHoldOrTerminated = checkTermination
    ? isAccountOnHold || isTerminated
    : false;
  
  const userDetails = useSelector((state) => state.contactDet);
  const hasMembershipNumber = userDetails?.membershipNumber && userDetails.membershipNumber.length > 0;


  const classes = useStyles();
  let isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  const renderProp = (props) => {
    if (
      inProgress &&
      inProgress !== InteractionStatus.Logout &&
      accountStatus !== "Active"
    ) {
      return <Redirect to={"/inactive"} />;
    }
    if (isAuthenticated) {
      const currentRoute = props.match.path;
      const isSaiceConnectRoute = saiceConnectRoutes.includes(currentRoute);

      // For saice-connect routes: check membership number and account status only
      if (isSaiceConnectRoute) {
        if (hasMembershipNumber && !isAccountOnHold && !isTerminated) {
          return <Component {...props} />;
        } else {
          return <Redirect to="/noaccess" />;
        }
      }

      // For other routes: check permissions as before
      let permissions = userEntitlement.find(
        (x) => x.route == props.match.path
      );

      if (
        permissions &&
        permissions.permissionsets != null &&
        permissions.permissionsets.length > 0 &&
        permissions.permissionsets[0] != null &&
        permissions.permissionsets[0].canread == "1"
      ) {
        return <Component {...props} />;
      } else return <Redirect to="/noaccess" />;
    } else if (inProgress === InteractionStatus.None) {
      return <Redirect to="/" />;
    } else {
      return null;
    }
  };

  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <div className={classes.content}>
      <NavBar siteNav={siteNav} />
      <div
        className={siteNav === "visible" ? classes.withNav : classes.withoutNav}
      >
        <Statusbar />
        <Route {...rest} render={(props) => renderProp(props)} />
      </div>
    </div>
  );
};

export default PrivateRoute;
